import React, { useEffect, useState } from "react";
import SpotlightCard from "../SpotlightCard/SpotlightCard";
import {
  SlideDots,
  SliderHolder,
  SliderWrapper,
  SpotlightCardItem,
} from "./SpotlightSlider.styles";

interface ISpotLightSlider {
  footerArrow: string;
  data: {
    id: number;
    mediaName: string;
    heading: string;
    date: string;
    link: string;
  }[];
}

const SpotlightSlider = ({ data, footerArrow }: ISpotLightSlider) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [length, setLength] = useState(data.length);
  const [deviceWidth, setDeviceWidth] = useState<any>();

  const [touchPosition, setTouchPosition] = useState(null);

  useEffect(() => {
    setDeviceWidth(window.innerWidth);
  }, []);

  useEffect(() => {
    setLength(data.length);
  }, [data]);

  const next = () => {
    if (currentIndex < length - 1) {
      setCurrentIndex((prevState) => prevState + 1);
    }
  };

  const prev = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prevState) => prevState - 1);
    }
  };

  const handleTouchStart = (e: any) => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = (e: any) => {
    const touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      next();
    }

    if (diff < -5) {
      prev();
    }

    setTouchPosition(null);
  };

  const timeoutRef = React.useRef<any>(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setCurrentIndex((prevIndex) =>
          prevIndex === data.length - 1 ? 0 : prevIndex + 1
        ),
      2500
    );

    return () => {
      resetTimeout();
    };
  }, [currentIndex]);
  return (
    <SliderWrapper>
      <SliderHolder
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        style={{
          transform: `translateX(-${
            currentIndex * (deviceWidth <= 767 ? 100 : 50)
          }%)`,
        }}
      >
        {data &&
          data.length > 0 &&
          data.map((item: any, index: number) => (
            <SpotlightCardItem key={item.id}>
              <SpotlightCard footerArrow={footerArrow} item={item} />
            </SpotlightCardItem>
          ))}
      </SliderHolder>
      <SlideDots className="slideshowDots">
        {data.map((_: any, idx: any) => (
          <div
            key={idx}
            className={`slideshowDot${currentIndex === idx ? " active" : ""}`}
            onClick={() => {
              setCurrentIndex(idx);
            }}
          ></div>
        ))}
      </SlideDots>
    </SliderWrapper>
  );
};

export default SpotlightSlider;
